<template>
  <div>
    <template v-if="$route.name != 'tournament' && $route.name != 'playerprofile' ">
      <b-row class="TitleArea">
        <b-col sm="12" lg="6">
          <h1 class="heading">Latest News</h1>
        </b-col>
        <b-col sm="12" lg="6" class="above769">
          <b-link to="/news" class="allNewsLink">
            <button class="Allbuttons">
              See More News
            </button>
          </b-link>
        </b-col>
      </b-row>
      <div class="below1200">
        <b-row :class="postsRow">
          <b-col
            lg="12"
            id="mobilePost"
            v-for="(posts, index) in posts.slice(0, 1)"
            :key="index"
          >
            <b-nav-item :to="'/news/' + posts.slug" class="NewsArtileOne">
              <div class="overflowImage">
                <b-img
                  :class="postImg"
                  :src="
                      posts.better_featured_image.source_url
                  "
                  onerror="this.onerror=null;this.src='https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/Header-Bar.png';"
                  fluid
                  alt="Responsive image"
                />
              </div>
              <div class="FirstPostContentBlock">
                <h1 class="postsTitle LeftImage">
                  <span v-html="posts.title.rendered"></span>
                </h1>
                <p class="date">{{dateTime[0]}}</p>
              </div>
              <!-- <span class="postText" v-html="posts.excerpt.rendered"></span> -->
            </b-nav-item>
          </b-col>
          <b-col
            lg="12"
            id="mobilePost"
            v-for="(posts, index) in posts.slice(1, 2)"
            :key="index"
          >
            <b-nav-item :to="'/news/' + posts.slug" class="NewsArtileOne">
              <div class="overflowImage">
                <b-img
                  :class="postImg"
                  :src="
                      posts.better_featured_image.source_url
                  "
                  onerror="this.onerror=null;this.src='https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/Header-Bar.png';"
                  fluid
                  alt="Responsive image"
                />
              </div>
              <div class="FirstPostContentBlock">
                <h1 class="postsTitle LeftImage">
                  <span v-html="posts.title.rendered"></span>
                </h1>
                <p class="date">{{dateTime[1]}}</p>
              </div>
              <!-- <span class="postText" v-html="posts.excerpt.rendered"></span> -->
            </b-nav-item>
          </b-col>
          <b-col
            lg="12"
            id="mobilePost"
            v-for="(posts, index) in posts.slice(2, 3)"
            :key="index"
          >
            <b-nav-item :to="'/news/' + posts.slug" class="NewsArtileOne">
              <div class="overflowImage">
                <b-img
                  :class="postImg"
                  :src="
                      posts.better_featured_image.source_url
                  "
                  onerror="this.onerror=null;this.src='https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/Header-Bar.png';"
                  fluid
                  alt="Responsive image"
                />
              </div>
              <div class="FirstPostContentBlock">
                <h1 class="postsTitle LeftImage">
                  <span v-html="posts.title.rendered"></span>
                </h1>
                <p class="date">{{dateTime[2]}}</p>
              </div>
              <!-- <span class="postText" v-html="posts.excerpt.rendered"></span> -->
            </b-nav-item>
          </b-col>
          <!-- <b-col
            lg="12"
            id="mobilePost"
            v-for="(posts, index) in posts.slice(3, 4)"
            :key="index"
          >
            <b-nav-item :to="'/news/' + posts.slug" class="NewsArtileOne">
              <div class="overflowImage">
                <b-img
                  :class="postImg"
                  :src="
                      posts.better_featured_image.source_url
                  "
                  onerror="this.onerror=null;this.src='https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/Header-Bar.png';"
                  fluid
                  alt="Responsive image"
                />
              </div>
              <div class="FirstPostContentBlock">
                <h1 class="postsTitle LeftImage">
                  <span v-html="posts.title.rendered"></span>
                </h1>
                <p class="date">{{dateTime[3]}}</p>
              </div>
            </b-nav-item>
          </b-col> -->
        </b-row>
        <div sm="12" lg="6" class="linkNews" >
          <b-link to="/news" class="allNewsLink">
            <button class="Allbuttons">
              See More News
            </button>
          </b-link>
        </div>
      </div>
      <div class="above1200">
        <b-row :class="postsRow">
          <b-col
            lg="6"
            id="mobilePost"
            v-for="(posts, index) in posts.slice(0, 1)"
            :key="index"
          >
            <b-nav-item :to="'/news/' + posts.slug" class="NewsArtileOne">
              <div class="overflowImage">
                <b-img
                  :class="postImg"
                  :src="
                      posts.better_featured_image.source_url
                  "
                  onerror="this.onerror=null;this.src='https://ocs-sport.ams3.cdn.digitaloceanspaces.com/alpstourgolf/2024/11/Header-Bar.png';"
                  fluid
                  alt="Responsive image"
                />
              </div>
              <div class="FirstPostContentBlock">
                <h1 class="postsTitle LeftImage">
                  <span v-html="posts.title.rendered"></span>
                </h1>
                <p class="date">{{dateTime[0]}}</p>
              </div>
              <!-- <span class="postText" v-html="posts.excerpt.rendered"></span> -->
            </b-nav-item>
          </b-col>
          <b-col
          >
            <b-row>
              <b-col 
                lg="12"
                id="mobilePost"
                v-for="(posts, index) in posts.slice(1, 2)"
                :key="index">
                  <b-nav-item :to="'/news/' + posts.slug">
                    <b-row class="rightHomePosts">
                      <b-col class="noPadSmallImage">
                        <div class="overflowImage newsSmallImage" v-bind:style="{ 'background-image': 'url(' +
                                posts.better_featured_image.source_url + ')' }">
                        </div>
                      </b-col>
                      <b-col lg="8">
                        <h1 class="postsTitle rightTitles">
                          <span v-html="posts.title.rendered"></span>
                        </h1>
                        <p class="date">{{dateTime[1]}}</p>
                      </b-col>
                    </b-row>
                  </b-nav-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col 
                lg="12"
                id="mobilePost"
                v-for="(posts, index) in posts.slice(2, 3)"
                :key="index">
                  <b-nav-item :to="'/news/' + posts.slug">
                    <b-row class="rightHomePosts">
                      <b-col class="noPadSmallImage">
                        <div class="overflowImage newsSmallImage" v-bind:style="{ 'background-image': 'url(' +
                                posts.better_featured_image.source_url + ')' }">
                        </div>
                      </b-col>
                      <b-col lg="8">
                        <h1 class="postsTitle rightTitles">
                          <span v-html="posts.title.rendered"></span>
                        </h1>
                        <p class="date">{{dateTime[2]}}</p>
                      </b-col>
                    </b-row>
                  </b-nav-item>
              </b-col>
            </b-row>
            <b-row>
              <b-col 
                lg="12"
                id="mobilePost"
                v-for="(posts, index) in posts.slice(3, 4)"
                :key="index">
                  <b-nav-item :to="'/news/' + posts.slug">
                    <b-row class="rightHomePosts">
                      <b-col class="noPadSmallImage">
                        <div class="overflowImage newsSmallImage" v-bind:style="{ 'background-image': 'url(' +
                                posts.better_featured_image.source_url + ')' }">
                        </div>
                      </b-col>
                      <b-col lg="8">
                        <h1 class="postsTitle rightTitles">
                          <span v-html="posts.title.rendered"></span>
                        </h1>
                        <p class="date">{{dateTime[3]}}</p>
                      </b-col>
                    </b-row>
                  </b-nav-item>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </template>
    <template v-else>
        <b-row :class="postsRow">
          <b-col
            lg="4"
            id="mobilePost"
            v-for="(posts, index) in postTourn.slice(0, 3)"
            :key="'sixteendex' + index"
          >
            <b-nav-item :to="'/news/' + posts.slug" class="NewsArtileOne">
              <div class="overflowImage">
                <b-img
                  :class="postImg"
                  :src="
                      posts.better_featured_image.source_url
                  "
                  onerror="this.onerror=null;this.src='https://ams3.digitaloceanspaces.com/ocs-sport/cpt/2026/01/course.png';"
                  fluid
                  alt="Responsive image"
                />
              </div>
              <div class="FirstPostContentBlock">
                <p class="date">{{posts.PostnewDate}}</p>
                <h1 class="postsTitle LeftImage">
                  <span v-html="posts.title.rendered"></span>
                </h1>
              </div>
              <!-- <span class="postText" v-html="posts.excerpt.rendered"></span> -->
            </b-nav-item>
          </b-col>
        </b-row>
    </template>
  </div>
</template>

<script>
import apiCall from "@/services/api.js";
import axios from 'axios';
export default {
  name: "posts",
  props: ["config", 'tag', "course_code", "Year", 'count', 'featuredTrue', 'tournID'],
  data() {
    return {
      posts: [],
      tournPosts: [],
      postsRow: "posts",
      postImg: "postImg",
      postTourn: []
    };
  },
  computed: {
    dateTime:function(){
      let arr = [];
      console.log("arr")
      console.log(arr)
      this.posts.forEach((value) => {
        var dateOG = value.date.split('T')
        var splitDate = dateOG[0].split('-')
        var newDate = splitDate[2]+ '/' + splitDate[1] + '/' + splitDate[0]
        arr.push(newDate);
      });
      return arr
    },
    SecondDatetime: function() {
      let Allpost = this.posts
      console.log("Allpost")
      console.log(Allpost)
      // let arr = [];

      this.posts.forEach((value) => {
          var dateOG = value.date.split('T')
          var splitDate = dateOG[0].split('-')
          var newDate = splitDate[2]+ '/' + splitDate[1] + '/' + splitDate[0]        
          value.PostnewDate = newDate;
      });
      return Allpost
    },
  },
  methods: {
    tournamentNews: function () {
      console.log('news added')
      console.log('tournament News')
        axios //add API Call
          .get('https://wp-mena.ocs-software.com/wp-json/wp/v2/posts?tags=' + this.tag + "&randomadd=" + new Date().getTime())
          .then((response) => (this.postTourn = response.data));
      },
  },
  created() {
    const json = "wp/v2/posts";
    apiCall
      .wpInfo(json)
      .then(({ data }) => {
        this.posts = data;
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },
  mounted() {
    if (this.$route.name == 'tournament') {
      this.tournamentNews();      
    }
  }
};
</script>

<style scoped>
a.allNewsLink {
  text-decoration: none!important;
}
.linkNews {
  position: relative;
  top: -15px;
}
li.nav-item.NewsArtileOne:hover {
  transform: translateY(-10px);
}
li.nav-item.NewsArtileOne {
  border-radius: 6px;
    transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.rightHomePosts:hover {
  transform: translateY(-10px);
}
.TitleArea {
  padding-bottom: 30px;
}
.noPadSmallImage {
  padding-left: 0px;
}
.rightHomePosts {
  border: 1px solid #E0E0E0;
  border-radius: 6px;
    transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  /* border-left: 0px; */
}
li.nav-item.NewsArtileOne > a {
  padding-left: 0px;
}
.overflowImage.newsSmallImage {
  height: 190px;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 6px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.Allbuttons {
  float: right;
  width: 244px;
  height: 50px;
  background: transparent;
  color: #152229;
  font-weight: 500;
  border-radius: 30px;
  border: 1px solid #C8102E;
  font-size: 16px;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
}
.Allbuttons:hover {
  float: right;
  width: 244px;
  height: 50px;
  background: #C8102E;
  color: #fff;
  font-weight: 500;
  border-radius: 50px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
}
.heading{
  font-weight: 600;
  font-size: 40px;
  color: #C8102E;
  padding-bottom: 10px;
}
.FirstPostContentBlock {
  border: 1px solid #E0E0E0;
  width: 100%;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  padding: 35px;
  padding-top: 10px;
  padding-bottom: 59px;
}
p.date {
  color: #C8102E;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 0;
}
h1.postsTitle.LeftImage {
  font-weight: 600;
}
h1.postsTitle.rightTitles {
  font-size: 24px;
}
h1.postsTitle.rightTitles > span {
  font-size: 24px;
}
img.imageRight.img-fluid.postImg {
  border-radius: 50px;
  max-width: 100%;
  height: 188px;
  width: auto;
  float: right;
}
.img-fluid {
  max-width: 100%;
  height: auto;
  width: 100%;
}
span.postText {
  font-size: 12pt;
}
h1.postsTitle {
  font-size: 24px;
  padding-top: 15px;
  padding-bottom: 15px;
  color: #152229;
  font-weight: 600;
}
.overflowImage {
  overflow: hidden;
  /* height: 278px; */
  border-top-right-radius: 6px;
  border-top-left-radius: 6px;
  max-height: 415px;
}
#mobilePost:last-child {
  /* padding-right: 0px; */
}

.postRow {
  padding-bottom: 10px;
}
::v-deep .nav-link {
  color: black !important;
  width: 100%;
  text-align: left;
}
.moreNews>a{
  background-color: transparent;
  color: #C8102E!important;
}
#leftMore{
  color: #fff;
  background-color: #C8102E;
  border-radius: 10px;
  width: 20px;
  height: 20px;
  padding: 3px;
}
@media only screen and (max-width: 480px) {
  ::v-deep .nav-link {
    width: 100%;
  }
  #mobilePost {
    padding-top: 2%;
    padding-bottom: 2%;
  }
}
@media only screen and (max-width: 769px) {
  .above769 {
    display: none;
  }
}
@media only screen and (max-width: 990px) {
  li.nav-item.NewsArtileOne > a {
    padding-left: 0px;
    padding-right: 0px;
  }
  .overflowImage.newsSmallImage {
    height: 190px;
    border-radius: 25px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: bottom;
  }
  .FirstPostContentBlock {
    height: auto;
  }
  .Allbuttons {
    float: none;
    width: 244px;
    height: 50px;
    background: transparent;
    color: #152229;
    font-weight: 500;
    border-radius: 50px;
    border: 1px solid #C8102E;
    margin-top: 30px !important;
    text-align: center;
    margin: auto;
    display: block;
    transition: all 0.4s ease;
    /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
    transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  }
  .Allbuttons:hover {
    float: none;
    width: 244px;
    height: 50px;
    background: #C8102E;
    color: #fff;
    font-weight: 500;
    border-radius: 50px;
    border: 1px solid #E8E8E8;
    margin-top: 30px !important;
    text-align: center;
    margin: auto;
    display: block;
    transform: translateY(-10px);
  }
  .heading {
    font-weight: 600;
    font-size: 40px;
    color: #C8102E;
    text-align: center;
  }
}
@media only screen and (max-width: 1165px) {
  #mobilePost:last-child {
    padding-right: 15px;
    margin-top: 2em;
  }
  div#mobilePost {
    margin-top: 1em;
  }
}
@media only screen and (min-width: 1202px) {
  .below1200 {
    display: none;
  }
}
@media only screen and (max-width: 1201px) {
  .above1200 {
    display: none;
  }
}
@media only screen and (max-width: 1350px) {
  .overflowImage.newsSmallImage {
    height: 100%;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 6px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
}
</style>
